import api from './api';

const conveyancerService = {
  getMyProfile: () => api.get('/conveyancers/profile/me').then((r) => r.data),
  saveMyProfile: (data) => api.put('/conveyancers/profile/me', data).then((r) => r.data),
  registerCandidates: (params = {}) => api.get('/conveyancers/register-candidates', { params }).then((r) => r.data),
  listDocuments: () => api.get('/conveyancers/documents').then((r) => r.data),
  deleteDocument: (id) => api.delete(`/conveyancers/documents/${id}`).then((r) => r.data),
  uploadDocument: (file, documentType, onProgress) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('documentType', documentType);
    fd.append('documentName', file.name);
    return api.post('/uploads/documents', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded * 100) / (e.total || 1))),
    }).then((r) => r.data);
  },
  dashboard: () => api.get('/conveyancers/dashboard').then((r) => r.data),
};

export default conveyancerService;
